import { render, staticRenderFns } from "./text-pillars.vue?vue&type=template&id=0cc45642&scoped=true&"
var script = {}
import style0 from "./text-pillars.vue?vue&type=style&index=0&id=0cc45642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc45642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc45642')) {
      api.createRecord('0cc45642', component.options)
    } else {
      api.reload('0cc45642', component.options)
    }
    module.hot.accept("./text-pillars.vue?vue&type=template&id=0cc45642&scoped=true&", function () {
      api.rerender('0cc45642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-pillars.vue"
export default component.exports